// extracted by mini-css-extract-plugin
export var content = "more-content-module--content--24e37";
export var maContainer = "more-content-module--maContainer--5dee3";
export var root = "more-content-module--root--f2892";
export var title = "more-content-module--title--4a870";